import { Adapter as r } from "../../../adapter.js";
import { TicketFeeModel as t } from "./ticketFee.model.js";
class i extends r {
  adapt(e) {
    return new t({
      amount: e.amount,
      feeType: e.fee_type,
      flat: e.flat,
      name: e.name,
      rate: e.rate,
      voided: e.voided
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  i as TicketFeeAdapter
};
//# sourceMappingURL=ticketFee.adapter.js.map
